import MenuButton from 'components/header/menu-button';
import styles from './style.module.scss';
import Dropdown from 'components/dropdown';
import { useState, useEffect } from 'react';
import { SiteLanguage, SiteLanguageLabel, SiteNameSpace } from 'constants/locale';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';

type Props = {
 allowedLanguages: ReadonlyArray<SiteLanguage | string>
}

export default function LanguageSelectorExp({ allowedLanguages }: Props) {
  const [menuDropdownIsActive, setMenuDropdownIsActive] = useState(false);
  const { t, i18n, ready } = useTranslation(SiteNameSpace.Common);
  
  const toggleMenuDropdown = () => {
    setMenuDropdownIsActive(prev => !prev);
  };

  const changeLanguage = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
  };

  const menuLinks = allowedLanguages.map(languageCode => ({
    id: languageCode,
    label: `${t(SiteLanguageLabel[languageCode])} - ${languageCode.toUpperCase()}`,
    isLink: false,
    onClick: () => changeLanguage(languageCode),
  }));


  return (
    <MenuButton className={styles.component} onClick={toggleMenuDropdown} closeMenu={() => setMenuDropdownIsActive(false)}>  
      <>
        <div id="language-menu">
          {ready ? i18n.language.toUpperCase() : ''}
        </div>
        {menuDropdownIsActive && <Dropdown items={menuLinks} className={styles.dropdown} />}
      </>
    </MenuButton>
  );
}